import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import { MutableRefObject } from 'react';
import { useTheme } from '@mui/material/styles';
interface TextEditorProps {
  editorRef: MutableRefObject<TinyMCEEditor | null>;
  content: string;
  setContent: (content: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export default function TextEditor({
  editorRef,
  content,
  setContent,
  placeholder,
  disabled = false,
}: TextEditorProps) {
  const theme = useTheme();
  return (
    <Editor
      apiKey={import.meta.env.VITE_TINYMCE_API_KEY}
      onInit={(_evt, editor) => (editorRef.current = editor)}
      value={content}
      onEditorChange={(newContent) => setContent(newContent)}
      disabled={disabled}
      init={{
        placeholder: placeholder,
        branding: false,
        height: '100%',
        width: '100%',
        color_default_foreground: theme.palette.text.primary,
        skin: theme.palette.mode !== 'dark' ? 'oxide' : 'oxide-dark',
        content_css: theme.palette.mode !== 'dark' ? 'default' : 'dark',
        font_family_formats:
          'Sans Serif=sans-serif; Serif=serif; Fixed Width=monospace; Wide=arial black, sans-serif; Narrow=arial narrow, sans-serif; Comic Sans MS=comic sans ms,sans-serif; Garamond=garamond, times new roman, serif; Georgia=georgia,serif; Tahoma=tahoma,sans-serif; Trebuchet MS=trebuchet ms,sans-serif; Verdana=verdana,sans-serif;',
        plugins:
          'anchor autolink charmap code codesample emoticons image link lists media searchreplace table visualblocks wordcount linkchecker',
        menu: {
          file: {
            title: 'File',
            items: 'newdocument preview importword exportpdf print',
          },
          edit: {
            title: 'Edit',
            items:
              'undo redo | cut copy paste pastetext | selectall | searchreplace',
          },
          view: {
            title: 'View',
            items:
              'code revisionhistory | visualaid visualchars visualblocks | spellchecker | preview fullscreen',
          },
          insert: {
            title: 'Insert',
            items:
              'image link pageembed inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime',
          },
          format: {
            title: 'Format',
            items:
              'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
          },
          table: {
            title: 'Table',
            items:
              'inserttable | cell row column | advtablesort | tableprops deletetable',
          },
          help: { title: 'Help', items: 'help' },
        },
        toolbar:
          'undo redo | styles | bold italic underline forecolor backcolor | link image code | align bullist numlist | removeformat',
      }}
    />
  );
}
